import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

// Connects to data-controller="sortable"
export default class extends Controller {

	static values = {
		itemSelector: String,
		handleSelector: String,
	}

	static outlets = [ 'update-subscriber' ]

	connect() {
		const sortableOptions = {
			onStart:  () => { this.dispatch('start') },
			onEnd:    () => { this.dispatch('end') },
			onUpdate: () => { this.dispatch('updateOrder') },
		}

		if (this.hasItemSelectorValue) {
			sortableOptions.draggable = this.itemSelectorValue
		}

		if (this.hasHandleSelectorValue) {
			sortableOptions.handle = this.handleSelectorValue
		}

		this.sortable = new Sortable(this.element, sortableOptions)
	}
}
